import { Spin, message } from "antd";
import { useEffect, useState } from "react";
import apiFactory from "../../../../api";
import "./style.scss";

const TextPreview = ({ fileId }) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!fileId) return;
    const abortController = new AbortController();

    const fetchText = async () => {
      try {
        setLoading(true);
        const payload = {
          limit: 1000,
          page: 0,
          search: {
            fileId: fileId,
          },
        };
        const response = await apiFactory.previewApi.fetchTextPreview(
          payload,
          abortController.signal,
        );

        if (response?.data?.data) {
          const lines = response.data.data
            .map((row) => row[0]?.value || "")
            .join("\n");
          setText(lines);
        } else {
          setText(JSON.stringify(response.data, null, 2));
        }
      } catch (err) {
        if (err.name !== "CanceledError") {
          console.error("Error file text:", err);
          setText("Error");
          message.error("Error");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchText();

    return () => abortController.abort();
  }, [fileId]);

  return (
    <div className="text-preview-container">
      {loading ? (
        <div className="text-loading">
          <Spin tip="Loading..." />
        </div>
      ) : (
        text || "File empty."
      )}
    </div>
  );
};

export default TextPreview;
